export class TutorialInputModel {
  constructor(
    public boxDimentions: TutorialDimentionsModel,
    public textDimentions: TutorialDimentionsModel,
    public text: string
  ) {}
}

export class TutorialDimentionsModel {
  constructor(
    public top: number,
    public right: number,
    public width: number,
    public height: number
  ) {}
}
